import $ from 'jquery';
import YouTubeIframeLoader from 'youtube-iframe';

export default function (elemSelector, options) {
  const self = {
    elem: null,
    options: null,
    ytPlayerLoaded: false,
    ytIntervals: [],
    ytTrackingStatus: [],
    ytId: '',
    yTContainer: null,
    yTPlayer: null,
    identifier: Math.round(Math.random() * 99999).toString(),
    defaultOptions: {
      ytWrapperId: 'brandhub-youtube-video-container',
      autoplay: true,
      closeButton: true,
      ratioW: 16,
      ratioH: 9,
    },

    init (elem, initialOptions = {}) {
      self.defaultOptions.ytWrapperId = `brandhub-youtube-video-container-${self.identifier}`;
      self.elem = elem;
      self.options = $.extend(self.defaultOptions, initialOptions);
      self.loadYTPlayer();

      $(window).on('brandhub-video-playback', (event, identifier) => {
        if (identifier !== self.identifier) {
          self.pause();
        }
      });
    },

    reInit (elem, newOptions) {
      self.init(elem, newOptions);
    },

    loadYTPlayer () {
      if (self.ytPlayerLoaded) {
        return;
      }

      if (!self.options.ytId) {
        self.ytPlayerLoaded = true;
        return;
      }

      // create a wrapper for the youtube player
      if ($(`#${self.options.ytWrapperId}`).length === 0) {
        self.elem.append(`<div id="${self.options.ytWrapperId}" class="brandhub-video-iframe" enablejsapi="1"></div>`);
      }

      // create a close button for the youtube player
      if (self.options.closeButton && !$(self.elem.find('.brandhub-icon-close')).length) {
        self.elem.append('<span class="brandhub-icon brandhub-icon-close brandhub-youtube-video__close-icon"></span>');
      }

      self.yTContainer = $(`#${self.options.ytWrapperId}`);
      const w = self.elem.width();
      const h = self.options.ratioH ? (w / self.options.ratioW) * self.options.ratioH : null;

      const onYTLoaded = (YT) => {
        self.onYoutubeLoaded(YT, w, h);
      };

      // check if YT was already loaded (e.g. from gtm.js, or from other component which is not using the YouTubeIframeLoader)
      if (window.YT) {
        if (window.console && window.console.warn) {
          window.console.warn('WARNING: YouTube Iframe API was already loaded by some external script');
        }
        // always be async
        setTimeout(() => {
          onYTLoaded(window.YT);
        }, 0);
      } else {
        YouTubeIframeLoader.load(onYTLoaded);
      }

      self.ytPlayerLoaded = true;
    },

    onYoutubeLoaded (YT, w, h) {
      self.yTPlayer = new YT.Player(self.yTContainer.get(0), {
        width: w,
        height: h,
        videoId: self.options.ytId,
        playerVars: {
          version: 3, rel: 0, showinfo: 0, color: 'white',
        },
        events: {
          onReady (event) {
            // animate height
            if (h !== null) {
              self.elem.animate({
                height: h,
              });
            }

            const ytPlayer = event.target;
            // inform videoContainer that it's ready (listener can decide when to start video itself)
            self.yTContainer.trigger('brandhubYTPlayerReady');

            // autoplay video
            if (self.options.autoplay) {
              ytPlayer.playVideo();
            }
          },
          onStateChange (e) {
            if (e.data === YT.PlayerState.PLAYING) {
              $(window).trigger('brandhub-video-playback', self.identifier);
            }
          },
        },
      });
    },

    play () {
      if (self.ytPlayerLoaded && $.contains(document, self.elem[0]) && self.yTPlayer.playVideo instanceof Function) {
        self.yTPlayer.playVideo();
      }
    },

    pause () {
      if (self.yTPlayer && $.contains(document, self.elem[0]) && self.yTPlayer.pauseVideo instanceof Function) {
        self.yTPlayer.pauseVideo();
      }
    },

    destroy () {
      if (self.yTPlayer && $.contains(document, self.elem[0])) {
        self.yTPlayer.stopVideo();
        self.yTPlayer.destroy();
        self.yTPlayer = null;
        $(`#${self.options.ytWrapperId}`).remove();
      }
    },
  };

  self.init($(elemSelector).first(), options);

  return self;
}



// WEBPACK FOOTER //
// ./custom_dependencies/brandhub-embxp-frontend/daimler-brandhub-modules/daimler-brandhub-design/daimler-brandhub-design-package/frontend/src/common/js/youtubeplayer/youtubeplayer.js